module.exports = __webpack_public_path__ + "static/media/Monza.d0c8a7a6.jpg";